document.addEventListener('DOMContentLoaded', function() {
  const stickyATC = document.querySelector('.sticky-atc-wrapper');
  const addToCartBtn = document.querySelector('.product-form__buttons [type="submit"]');
  const mobileQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;
  const SCROLL_THRESHOLD = 200;

  if (!stickyATC || !addToCartBtn) return;

  stickyATC.classList.remove('hidden');

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }

  function updateVisibility() {
    const isMobile = !mobileQuery || mobileQuery.matches;
    const scrolledPastThreshold = window.scrollY >= SCROLL_THRESHOLD;

    if (!isMobile) {
      stickyATC.classList.remove('is-visible');
      stickyATC.setAttribute('aria-hidden', 'true');
      return;
    }

    const shouldHide = !scrolledPastThreshold || isInViewport(addToCartBtn);
    stickyATC.classList.toggle('is-visible', !shouldHide);
    stickyATC.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  }

  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  updateVisibility();
  window.addEventListener('scroll', throttle(updateVisibility, 100), { passive: true });
  window.addEventListener('resize', throttle(updateVisibility, 150), { passive: true });

  if (mobileQuery && typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', updateVisibility);
  } else if (mobileQuery && typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(updateVisibility);
  }
});
